export default "__VITE_ASSET__DTg5O7me__"